// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"b2fa23a809053c6305c5","1656":"05d90ab05fafdbaeed35","3485":"b3e801849a79b5a466ec","5771":"a4e2a98efcfb7393c5bd","5810":"f63f10359069f886ce52","7432":"bf576075b1d8131aa273","7457":"4f8104223d5594bebb0f","7807":"382c331365e38d2fb775"}[chunkId] + "";
};